import React, { useRef } from "react";
import { Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import styled from "styled-components";
import { formatDesignDate, formatDesignDateAdd_11_30 } from "utils/formatDate";
import { findSpecificMenu, findSpecificSubMenu, isAllowed } from "utils/checkUserRigths";
import { usePermissions } from "context/PermissionsContext";
 
const StyledTableContainer = styled(TableContainer)`
  background-color: transparent;
  border: 1px solid #fff;
  border-radius: 5px;
  max-height: 75vh;
  overflow: auto;
  position: relative;
 
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;
`;
 
const StyledTable = styled(Table)`
  width: 100%;
  border-collapse: collapse;
  & td {
    font-size: 18px;
    font-family: "Karla", sans-serif;
    font-weight: 500;
    line-height: 22px;
    color: #ffffff;
    text-align: center;
    border: 1px solid #fff;
  }
  & th {
    background-color: #444444;
    font-weight: bold;
  }
`;
 
const StyledTableHeaderCell = styled(TableCell)`
  width: 33.33%;
  padding: 10px;
  font-size: 14px !important;
  font-weight: 400 !important;
  background-color: #444444;
  color: white;
  border: none !important;
  text-align: center !important;
  position: sticky;
  top: 0;
  z-index: 10;
`;
 
const StyledTableBodyCell = styled(TableCell)`
  width: 33.33%;
  padding: 10px;
  text-align: center;
  &:first-of-type {
    padding-left: 5px;
  }
  &:last-child {
    padding-right: 20px;
  }
`;
 
const StatusCell = styled(StyledTableBodyCell)`
  color: ${({ status }) => (status === "Success" ? "#50C878" : "#FF4C4C")} !important;
  font-weight: bold;
`;
 
const TimeCell = styled(StyledTableBodyCell)`
  color: #4da6ff !important;
  text-decoration: underline;
  text-underline-offset: 4px;
  cursor: pointer;
`;
 
const DesignStatusTable = ({ data, fetchNextPage, hasNextPage, isFetchingNextPage, handleClick, path }) => {
  const tableRef = useRef(null);
  const permissions = usePermissions();
//   const hasDeignImportAccess = isAllowed(
//   findSpecificSubMenu(findSpecificMenu("Vision Web", permissions), "Design Upadte"),
//   "export_design"
// );
 
  const handleScroll = () => {
    const element = tableRef.current;
    if (element) {
      const { scrollTop, scrollHeight, clientHeight } = element;
      if (scrollTop + clientHeight >= scrollHeight - 10 && hasNextPage && !isFetchingNextPage) {
        setTimeout(() => fetchNextPage(), 300);
      }
    }
  };
 
  return (
    <StyledTableContainer ref={tableRef} onScroll={handleScroll}>
      <StyledTable>
        <TableHead>
          <TableRow>
            <StyledTableHeaderCell>Import Time</StyledTableHeaderCell>
            <StyledTableHeaderCell>Design Count</StyledTableHeaderCell>
            <StyledTableHeaderCell>Import Status</StyledTableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((dataItem, index) => (
            <TableRow key={index}>
              <TimeCell onClick={() => handleClick(dataItem?.date, dataItem?.styleCount)}>
                {path !== "design-update" ? formatDesignDate(dataItem.date) : formatDesignDateAdd_11_30(dataItem.date)}
              </TimeCell>
              <StyledTableBodyCell>{dataItem.styleCount}</StyledTableBodyCell>
              <StatusCell status={dataItem.status}>{dataItem.status === "Success" ? "Success" : "Failed"}</StatusCell>
            </TableRow>
          ))}
          {isFetchingNextPage && (
            <TableRow>
              <StyledTableBodyCell colSpan={3} align="center">
                <Skeleton variant="rectangular" animation="wave" />
              </StyledTableBodyCell>
            </TableRow>
          )}
        </TableBody>
      </StyledTable>
    </StyledTableContainer>
  );
};
 
export default DesignStatusTable;